<script type="text/javascript">
	import Tooltip from './Tooltip.svelte';
	import FlagHelper from '../Helpers/FlagHelper';

	// Country code.
	export let cc = "";

 	let useFlagCC;
 	let useFlagName;
	let validFlag;
	$: {
		validFlag = FlagHelper.isValidFlag(cc);
		useFlagCC =	FlagHelper.toFlagCountryCode(cc);
		useFlagName = FlagHelper.toFlagCountryName(cc);
	};

</script>

{#if validFlag}
	<Tooltip text={useFlagName} inline={true}>
		<div class={"flag flag-"+useFlagCC}></div>
	</Tooltip>
{/if}

